<template>
    <div class="wisdom">
        <div>BEEN DOWN LATELY?</div>
        <div class="smaller">PLAY WITH YOUR MANDELBROT SET</div>
        <div class="canvas-container">
            <canvas ref="canvas"></canvas>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },

    mounted() {

    }
}
</script>

<style scoped>
.smaller {
    font-size: 0.5em;
    color: purple;
}
</style>



// WEBPACK FOOTER //
// src/components/Mandelbrot.vue